export default __webpack_public_path__ + "static/media/firstLevel.d0313811.webp";